export default "__VITE_ASSET__6YA$NAIh__"